import { compose, concat, equals, length, uniq } from 'ramda';

export const isSingleton = compose(equals(1), length);
export const concatUniq = compose(uniq, concat);
